// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::after,
*::before {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  background: #e0eafc;
  margin: 0;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-top: 0;
}

main {
  display: flex;
  flex-direction: column;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
  max-height: 545px;
  -o-object-fit: cover;
     object-fit: cover;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

a {
  display: inline-block;
}

address {
  font-style: normal;
}

table {
  width: 100%;
  text-align: center;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number],
input[type=number]:hover,
input[type=number]:focus {
  -webkit-appearance: none;
          appearance: none;
  -moz-appearance: textfield;
}

input[type=radio]:checked::before {
  transform: scale(1);
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.active {
  border: 2px solid #1683ff !important;
}

.base-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
  padding-top: 50px;
}

.container {
  width: 50%;
  padding: 20px;
  background: #fff;
  border-radius: 20px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.container__input {
  margin-bottom: 20px;
}
.container__input input[type=file] {
  display: none;
}
.container__input label {
  display: block;
  padding: 10px 15px;
  background-color: #007bff;
  color: #fff;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
}
.container__input label:hover {
  background-color: #0056b3;
}
.container__input-drag {
  height: 200px;
  border: 3px dashed #e0eafc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 10px auto;
  position: relative;
}
.container__input-drag--excel {
  height: 410px;
}
.container__input-drag input[type=file] {
  display: none;
}
.container__input-drag label {
  position: absolute;
  width: 100%;
  height: 100%;
  color: #ffffff;
  cursor: pointer;
}
.container__description {
  font-size: 20px;
  font-weight: 500;
  color: #34495e;
}
.container__btn-drag {
  font-size: 20px;
  font-weight: 500;
  color: #1683ff;
  cursor: pointer;
}
.container__support {
  font-size: 12px;
  color: gray;
  margin: 10px 0 15px 0;
}
.container__text {
  width: 100%;
  height: 200px;
  border: 3px solid #e0eafc;
}
.container__btn {
  padding: 10px 15px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.container__btn:hover {
  background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/scss/_base.scss","webpack://./src/scss/main.scss","webpack://./src/scss/utils/_utils.scss","webpack://./src/scss/layouts/_base-container.scss","webpack://./src/scss/layouts/_container.scss"],"names":[],"mappings":"AAAA;;;EAGE,sBAAA;ACCF;;ADEA;EACE,uBAAA;ACCF;;ADEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;ACCF;;ADEA;;;;;;;EAOE,aAAA;ACCF;;ADEA;EACE,aAAA;EACA,sBAAA;ACCF;;ADEA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;KAAA,iBAAA;ACCF;;ADEA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;ACCF;;ADEA;EACE,qBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,WAAA;EACA,kBAAA;ACCF;;ADEA;;EAEE,wBAAA;ACCF;;ADEA;;;EAGE,wBAAA;UAAA,gBAAA;EACA,0BAAA;ACCF;;ADEA;EACE,mBAAA;ACCF;;ADEA;EACE,WAAA;ACCF;;ADEA;EACE,mBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;AC5FA;EACE,oCAAA;AD+FF;;AEhGA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AFmGF;;AGxGA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iDAAA;AH2GF;AGzGE;EACE,mBAAA;AH2GJ;AGzGI;EACE,aAAA;AH2GN;AGxGI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AH0GN;AGxGM;EACE,yBAAA;AH0GR;AGrGE;EACE,aAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AHuGJ;AGrGI;EACE,aAAA;AHuGN;AGpGI;EACE,aAAA;AHsGN;AGnGI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AHqGN;AGjGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AHmGJ;AGhGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AHkGJ;AG/FE;EACE,eAAA;EACA,WAAA;EACA,qBAAA;AHiGJ;AG9FE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AHgGJ;AG7FE;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AH+FJ;AG7FI;EACE,yBAAA;AH+FN","sourcesContent":["*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.5;\n  background: #e0eafc;\n  margin: 0;\n  min-height: 100vh;\n  font-family: 'Poppins', sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin-top: 0;\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  max-height: 545px;\n  object-fit: cover;\n}\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\na {\n  display: inline-block;\n}\n\naddress {\n  font-style: normal;\n}\n\ntable {\n  width: 100%;\n  text-align: center;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type='number'],\ninput[type=\"number\"]:hover,\ninput[type=\"number\"]:focus {\n  appearance: none;\n  -moz-appearance: textfield;\n}\n\ninput[type=\"radio\"]:checked::before {\n  transform: scale(1);\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n","*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.5;\n  background: #e0eafc;\n  margin: 0;\n  min-height: 100vh;\n  font-family: \"Poppins\", sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin-top: 0;\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  max-height: 545px;\n  object-fit: cover;\n}\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\na {\n  display: inline-block;\n}\n\naddress {\n  font-style: normal;\n}\n\ntable {\n  width: 100%;\n  text-align: center;\n}\n\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type=number],\ninput[type=number]:hover,\ninput[type=number]:focus {\n  appearance: none;\n  -moz-appearance: textfield;\n}\n\ninput[type=radio]:checked::before {\n  transform: scale(1);\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.active {\n  border: 2px solid #1683ff !important;\n}\n\n.base-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  gap: 30px;\n  padding-top: 50px;\n}\n\n.container {\n  width: 50%;\n  padding: 20px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n}\n.container__input {\n  margin-bottom: 20px;\n}\n.container__input input[type=file] {\n  display: none;\n}\n.container__input label {\n  display: block;\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: #fff;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n}\n.container__input label:hover {\n  background-color: #0056b3;\n}\n.container__input-drag {\n  height: 200px;\n  border: 3px dashed #e0eafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 10px auto;\n  position: relative;\n}\n.container__input-drag--excel {\n  height: 410px;\n}\n.container__input-drag input[type=file] {\n  display: none;\n}\n.container__input-drag label {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  color: #ffffff;\n  cursor: pointer;\n}\n.container__description {\n  font-size: 20px;\n  font-weight: 500;\n  color: #34495e;\n}\n.container__btn-drag {\n  font-size: 20px;\n  font-weight: 500;\n  color: #1683ff;\n  cursor: pointer;\n}\n.container__support {\n  font-size: 12px;\n  color: gray;\n  margin: 10px 0 15px 0;\n}\n.container__text {\n  width: 100%;\n  height: 200px;\n  border: 3px solid #e0eafc;\n}\n.container__btn {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.container__btn:hover {\n  background-color: #0056b3;\n}",".active {\n  border: 2px solid #1683ff !important;\n}\n",".base-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  gap: 30px;\n  padding-top: 50px;\n}\n",".container {\n  width: 50%;\n  padding: 20px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n\n  &__input {\n    margin-bottom: 20px;\n\n    & input[type=\"file\"] {\n      display: none;\n    }\n\n    & label {\n      display: block;\n      padding: 10px 15px;\n      background-color: #007bff;\n      color: #fff;\n      text-align: center;\n      cursor: pointer;\n      border-radius: 5px;\n\n      &:hover {\n        background-color: #0056b3;\n      }\n    }\n  }\n\n  &__input-drag {\n    height: 200px;\n    border: 3px dashed #e0eafc;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin: 10px auto;\n    position: relative;\n\n    &--excel {\n      height: 410px;\n    }\n\n    & input[type=\"file\"] {\n      display: none;\n    }\n\n    & label {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      color: #ffffff;\n      cursor: pointer;\n    }\n  }\n\n  &__description {\n    font-size: 20px;\n    font-weight: 500;\n    color: #34495e;\n  }\n\n  &__btn-drag {\n    font-size: 20px;\n    font-weight: 500;\n    color: #1683ff;\n    cursor: pointer;\n  }\n\n  &__support {\n    font-size: 12px;\n    color: gray;\n    margin: 10px 0 15px 0;\n  }\n\n  &__text {\n    width: 100%;\n    height: 200px;\n    border: 3px solid #e0eafc;\n  }\n\n  &__btn {\n    padding: 10px 15px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #0056b3;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
